module.exports = __webpack_public_path__ + "static/media/cloud_storage.273e5ba2.svg";